import { render, staticRenderFns } from "./OrganDetailDepart.vue?vue&type=template&id=4b622251&scoped=true"
import script from "./OrganDetailDepart.vue?vue&type=script&lang=js"
export * from "./OrganDetailDepart.vue?vue&type=script&lang=js"
import style0 from "./OrganDetailDepart.vue?vue&type=style&index=0&id=4b622251&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b622251",
  null
  
)

export default component.exports